module.exports = {"511603001":"奎阁街道","511603002":"大佛寺街道","511603003":"龙塘街道","511603101":"桂兴镇","511603102":"观阁镇","511603103":"广兴镇","511603104":"代市镇","511603105":"观塘镇","511603106":"护安镇","511603107":"龙滩镇","511603108":"虎城镇","511603200":"小井乡","511603202":"光辉乡","511603203":"新桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511603.json
// module id = 2183
// module chunks = 0